import { Link } from 'react-router-dom';
import './landing.css';

/**
 * PART F4/J. Short on purpose: the honest version of this policy really is one
 * paragraph, because a player hands over nothing.
 */
export default function Privacy() {
  return (
    <div className="lf-landing">
      <div className="lf-shell">
        <nav className="lf-nav">
          <Link to="/" className="lf-wordmark" style={{ textDecoration: 'none' }}>
            Lobby<span>Fun</span>
          </Link>
          <Link to="/" className="lf-cta lf-cta--ghost">
            Back
          </Link>
        </nav>

        <main style={{ display: 'grid', gap: 'var(--space-6)', paddingBlock: 'var(--space-8)' }}>
          <p className="lf-eyebrow">Privacy</p>
          <h1 className="lf-h1" style={{ maxWidth: '18ch' }}>
            Players give us nothing.
          </h1>

          <p className="lf-lede" style={{ maxWidth: '58ch' }}>
            To play, a person needs no account, no email and no app. We store the score, the venue
            it was set at, and — only if the player chooses to save it — a nickname and a 4-digit
            PIN so their scores follow them. Nothing else. No email address, no phone number, no
            personal data, no advertising trackers.
          </p>

          <div style={{ display: 'grid', gap: 'var(--space-4)', maxWidth: '58ch' }}>
            <p style={{ margin: 0, color: 'var(--muted)' }}>
              A random ID is kept in the player&apos;s browser so a returning phone is recognised as
              the same player. Clearing browser data removes it, and their saved scores stay on the
              venue&apos;s leaderboard under their nickname.
            </p>
            <p style={{ margin: 0, color: 'var(--muted)' }}>
              Venue owners have an account with an email address and a password, used only to sign
              in and to contact them about their service.
            </p>
            <p style={{ margin: 0, color: 'var(--muted)' }}>
              Questions, or want something removed?{' '}
              <a href="mailto:hello@lobbyfun.com">hello@lobbyfun.com</a>.
            </p>
          </div>
        </main>

        <footer className="lf-footer">
          <span>© LobbyFun</span>
          <Link to="/">Home</Link>
        </footer>
      </div>
    </div>
  );
}
